// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DetachableView — 창(AppModal)과 같은 틀(appModal.css)을 쓰되, 제자리에서는 칸을 채우고 분리한 창에서는 그 창 전체를 채운다 */
.app-modal.detach-view {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  width: auto;
  max-width: none;
  max-height: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--color-bg);
  border: none;
  border-radius: 0;
  box-shadow: none;
}
.app-modal.detach-view.popped { height: 100%; }
.detach-view-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.detach-view-body > * {
  flex: 1 1 auto;
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  min-height: 0;
  border-left: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/DetachableView.css"],"names":[],"mappings":"AAAA,6FAA6F;AAC7F;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA,gCAAgC,YAAY,EAAE;AAC9C;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,4BAA4B;AAC9B","sourcesContent":["/* DetachableView — 창(AppModal)과 같은 틀(appModal.css)을 쓰되, 제자리에서는 칸을 채우고 분리한 창에서는 그 창 전체를 채운다 */\n.app-modal.detach-view {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  width: auto;\n  max-width: none;\n  max-height: none;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--color-bg);\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n.app-modal.detach-view.popped { height: 100%; }\n.detach-view-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.detach-view-body > * {\n  flex: 1 1 auto;\n  width: auto !important;\n  min-width: 0 !important;\n  max-width: none !important;\n  min-height: 0;\n  border-left: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
